module.exports = __webpack_public_path__ + "img/hardyDrillRelease2.f4d35594.png";